var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWvMblLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_720_612)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 0H0V32H32V0Z",
    fill: "#FF6B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3568 29.8461C16.9476 21.0707 16.8738 15.4707 18.3753 14.08C19.8768 12.6892 22.5476 12.7261 26.7938 12.4061C17.083 11.6923 16.9968 11.5323 16.3568 2.15381C15.7292 11.5323 15.6307 11.6923 5.91992 12.4061C10.1784 12.7138 12.9599 12.7877 14.3384 14.08C15.7168 15.3723 15.7661 21.0707 16.3568 29.8461Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_720_612"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWvMblLogo);
export default __webpack_public_path__ + "static/media/wv_mbl_logo.6beb5c1d801b3f6286637d21723503db.svg";
export { ForwardRef as ReactComponent };